interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg bg-background-50 border border-dashed border-background-300">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-film-line text-3xl" aria-hidden="true"></i>
      </span>
      <h3 className="mt-4 font-heading font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line" aria-hidden="true"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}